var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('c-source-page',{attrs:{"columns":_vm.columns,"filter":_vm.filter,"resource":_vm.resource,"table":_vm.table,"pagination":_vm.pagination,"exportExcelURL":"/orders/export"}},[_c('LogisticsImport')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }